<template>
  <a-card :style="{ width: '300px', margin: '16px' }">
    <div style="display: flex; justify-content: center; align-items: center">
      <div>
        <div>
          <span v-if="capital"> 首都 {{ capital }} </span>
          <span v-else>&nbsp;</span>
          <!-- 保留一行高度，避免跳格 -->
        </div>
        <div>時區 {{ city }}</div>
        <!-- <div>{{ getCountryFromTimezone(props.timezone) }} {{ country }}</div> -->
        <div style="color: #024d73; font-weight: bold">{{ utcOffset }}</div>
        <div style="font-size: 1.75em">{{ time }}</div>
        <div>{{ date }}</div>
      </div>
    </div>
  </a-card>
</template>

<script setup>
import { ref, onMounted, computed, onBeforeUnmount } from "vue";

const capitalTimezoneMap = {
  "Asia/Tokyo": "Tokyo",
  "Asia/Ho_Chi_Minh": "Hanoi",
  "Asia/Seoul": "Seoul",
  "Australia/Sydney": "Canberra",
  "Pacific/Auckland": "Wellington",
  "Asia/Singapore": "Singapore",
  "Asia/Bangkok": "Bangkok",
  "America/New_York": "Washington",
  "America/Toronto": "Ottawa",
  "Europe/London": "London",
  "Europe/Berlin": "Berlin",
  "Europe/Dublin": "Dublin",
  "Europe/Bratislava": "Bratislava",
  "Europe/Warsaw": "Warsaw",
  "Europe/Budapest": "Budapest",
  "Europe/Vienna": "Vienna",
  "Europe/Prague": "Prague",
  "Europe/Paris": "Paris",
  "Europe/Luxembourg": "Luxembourg",
  "Europe/Amsterdam": "Amsterdam",
  "Europe/Brussels": "Brussels",
};

// Props
const props = defineProps({
  city: String,
  country: String,
  timezone: String,
});

const time = ref("");
const date = ref("");
const utcOffset = ref("");
let intervalId = null;

const formatUtcOffset = (timeZone) => {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    timeZoneName: "shortOffset",
  });
  const timeZoneNamePart = formatter
    .formatToParts(new Date())
    .find((part) => part.type === "timeZoneName");

  if (!timeZoneNamePart) {
    return "UTC";
  }

  const normalizedOffset = timeZoneNamePart.value.replace("GMT", "");
  if (!normalizedOffset || normalizedOffset === "0") {
    return "UTC+00:00";
  }

  const match = normalizedOffset.match(/^([+-])(\d{1,2})(?::?(\d{2}))?$/);
  if (!match) {
    return timeZoneNamePart.value.replace("GMT", "UTC");
  }

  const [, sign, hours, minutes = "00"] = match;
  return `UTC${sign}${hours.padStart(2, "0")}:${minutes}`;
};

// 更新時間函式
const updateTime = () => {
  const now = new Date();
  time.value = new Intl.DateTimeFormat("zh-TW", {
    timeZone: props.timezone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(now);
  date.value = new Intl.DateTimeFormat("zh-TW", {
    timeZone: props.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    weekday: "long",
  }).format(now);
  utcOffset.value = formatUtcOffset(props.timezone);
};

const capital = computed(() => {
  return capitalTimezoneMap[props.timezone] || null;
});

onMounted(() => {
  updateTime();
  intervalId = setInterval(updateTime, 10000);
});

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});
</script>
